export interface WorkLocationDto {
  WorkLocationID: number;
  Name: string;
  bActive: boolean;
  TradeClassesCount: number;
}
